module.exports = __webpack_public_path__ + "static/recipe_01-47c98a6231663e9be359c1564c2015db.png";